var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 5.5C20.4985 5.5 5.5 20.4985 5.5 39C5.5 57.5015 20.4985 72.5 39 72.5C57.5015 72.5 72.5 57.5015 72.5 39C72.5 20.4985 57.5015 5.5 39 5.5ZM0.5 39C0.5 17.737 17.737 0.5 39 0.5C60.263 0.5 77.5 17.737 77.5 39C77.5 60.263 60.263 77.5 39 77.5C17.737 77.5 0.5 60.263 0.5 39Z",
    fill: "#808B99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8987 29.3737C55.7969 30.4223 55.675 32.0005 54.6263 32.8987L35.9467 48.8987C34.946 49.7559 33.4517 49.6892 32.5313 48.7463L25.2109 41.2463C24.2465 40.2582 24.2657 38.6754 25.2538 37.711C26.2419 36.7466 27.8247 36.7658 28.7891 37.7538L34.4732 43.5774L51.3737 29.1013C52.4223 28.2032 54.0005 28.3251 54.8987 29.3737Z",
    fill: "#808B99"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/Checked.d49d045a9e70aaa33ace01bd9eb824c0.svg";
export { ForwardRef as ReactComponent };